import { createReducer } from './utils'

export default createReducer({
    ORDER_STATUS: (state, action) => {
        return {
            ...action.data
        }
    }
})




// WEBPACK FOOTER //
// ./src/reducers/orderStatus.jsx